import { Store } from 'store/index';

const getNumberOfFiltersApplied = (store: Store) => Object.values(store.search.settings.filters).length;

export default getNumberOfFiltersApplied;
